<template>
<div>
    <ul>
              <li>
                <div class="media">
                  <div class="order-data">
                    <svg width="18" height="22" fill="none">
                      <use xlink:href="#icon-invoice" />
                    </svg>
                  </div>
                  <div class="media-body">
                    <h6>{{_T('Order Date')}}</h6>
                    <h5>Sun, 14 Apr, 19:12</h5>
                  </div>
                </div>
              </li>
              <li>
                <div class="media">
                  <div class="order-data">
                    <svg width="21" height="21" fill="none">
                      <use xlink:href="#icon-calender" />
                    </svg>
                  </div>
                  <div class="media-body">
                    <h6>{{_T('Order ID')}}</h6>
                    <h5>5875875785</h5>
                  </div>
                </div>
              </li>
            </ul>
            <div class="text-center">
              <img
                src="/images/order/success-order.png"
                alt=""
                class="img-fluid"
              />
            </div>
</div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
computed:{
  ...mapGetters(['_T'])
}
}
</script>

<style lang="scss" scoped>
  ul {
      padding: calc(#{$px10} + (24 - 10) * ((100vw - #{$px320}) / (1920 - 320))) 0
        calc(#{$px15} + (33 - 15) * ((100vw - #{$px320}) / (1920 - 320)));
      display: flex;
      li {
        &:first-child {
          width: 100%;
        }
        .media {
          align-items: center;
          .order-data {
            width: $px45;
            height: $px45;
            background-color: $color-primary;
            border-radius: 100%;
            display: flex;
            align-items: center;
            justify-content: center;
          }
          .media-body {
            padding-left: calc(
              #{$px4} + (20 - 4) * ((100vw - #{$px320}) / (1920 - 320))
            );
            h6 {
              margin-bottom: $px4;
            }
            h5 {
              margin-bottom: 0;
              font-weight: 600;
              letter-spacing: 0.02em;
            }
          }
        }
      }
    }
</style>